export const ORIGIN = ((window as any).XDM_ORIGIN || '').includes('staging')
  ? 'https://staging.bb-inf.net'
  : 'https://bitbucket.org';
export const TWO_STEP_VERIFICATION_LINK = `${ORIGIN}/account/settings/two-step-verification/manage`;
export const DOCS_DEPLOYMENTS =
  'https://confluence.atlassian.com/bitbucket/bitbucket-deployments-940695276.html';
export const DOCS_GETTING_STARTED_URL =
  'https://confluence.atlassian.com/x/qYU5Lw';
export const DOCS_RUNNERS =
  'https://support.atlassian.com/bitbucket-cloud/docs/runners/';

export const YML_FILE_NAME = 'bitbucket-pipelines.yml';
export const YML_COMMIT_MESSAGE = 'Initial Bitbucket Pipelines configuration';
export const YML_DEPLOYMENTS_COMMIT_MESSAGE =
  'Initial Bitbucket Deployments configuration';
export const VALID_ENVIRONMENT_NAME = '[a-zA-Z0-9 \\-_]+';

export const INITIALLY_VISIBLE_TEMPLATES = 9;
